<template>
  <!-- <div class="card" style="border-radius: 10px">  :styles="'meduim'"-->
  <card
    :title="title"
    :styles="'overflow-none'"
    :icon="{ class: classCSS, styles: 'padding:5px;' }"
    :enableCollapse="true"
    :fullScreen="false"
    :isCollapsed="Collapsed"
    :id="Id.toString()"
    :showFooter="editable || formHasChanged()"
  >
    <template v-slot:card-edit>
      <span :style="!hasRole ? { display: 'none' } : ''"
        ><i
          class="scf-edit"
          @click="editable = !editable"
          :style="editable ? { color: '#9bcd41' } : ''"
          style="font-size: 24px; cursor: pointer"
      /></span>
    </template>

    <template v-slot:card-drop-down> </template>

    <template v-slot:card-body-title> </template>

    <template v-slot:card-body-container>
      <div class="row row-padding-bottom-10" style="padding: 0rem 1rem">
        <div
          v-for="(item, index) in items"
          v-bind:key="index"
          class="row mb-2"
        >
          <div class="dm-card-param-name dm-align-left">
            <div class="title-col-card">
              &ensp;
              <span>{{ this.GetParameterTraduction(item.key) }}:</span>
            </div>
            <div
              class="source"
              style="font-size: 9px"
              :style="item.Source != '' ? '' : 'margin-bottom: 11px;'"
            >
               {{
                
                !this.translationExists("pages.DeviceDetails.DeviceSources." + item.Source)
                ? item.Source
                : this.$t("pages.DeviceDetails.DeviceSources." + item.Source)
            }}
            </div>
          </div>
          <div class="dm-card-param-name dm-align-right">
            <span v-if="editable && !item.ReadOnly">
              <select 
                v-if="item.AllowedValues != null"
                class="form-select"
                v-model="formData[item.key]"
                :key="componentKey">
                <option v-for="option of Object.values(item.AllowedValues)" :key="option.value" :value="option.value">{{ option.name }}</option>
              </select>
              <!-- <wj-combo-box
                v-if="item.AllowedValues != null"
                :key="componentKey"
                :id="item.key"
                :itemsSource="item.AllowedValues"
                :displayMemberPath="'name'"
                :selectedValuePath="'value'"
                v-model="formData[item.key]"
              >
              </wj-combo-box> -->

              <div
                data-v-a1e2b94e=""
                v-if="item.AllowedValues == null"
                id="Description"
                style="width: 100%; height: 35px"
                class="wj-control wj-content wj-dropdown wj-state-collapsed wj-combobox wj-state-focus wj-state-focused"
                tabindex="-1"
                _wjsiblingid="1"
              >
                <div class="wj-template">
                  <div class="wj-input">
                    <div class="wj-input-group wj-input-btn-visible">
                      <input
                        wj-part="input"
                        :placeholder="
                          $t('pages.FirmwareCompaign.Placeholder.Valeur')
                        "
                        :id="item.key"
                        v-model="formData[item.key]"
                        type="text"
                        class="wj-form-control"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        @change="save"
                      />
                      <span
                        wj-part="btn"
                        class="wj-input-group-btn wj-state-disabled"
                        disabled="disabled"
                        style="display: none"
                      >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </span>

            <!-- <span class="field-value" v-show="!showField(item.key)" @click="focusField(item.key)">{{item.value }}</span> -->
            <span
              v-else
              :style="
                formData[item.key] != formInitData[item.key]
                  ? { 'font-weight': 'bold' }
                  : ''
              "
            >
              {{ this.GetParametersTraductionValue(formData[item.key], item.key) }}
            </span>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:card-footer>
      <div class="row" style="margin-top: 20px">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button
            v-if="formHasChanged()"
            id="Reset"
            class="btn btn-sm btn-reset-form ml-2"
            @click.prevent="RebaseForm"
          >
            <i class="scf-cancel"/>
            {{ $t("pages.FirmwareAdd.Reset") }}
          </button>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import { computed } from "vue";
import glyphDown from "../assets/icons/wj-glyph-down.svg";
import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.vue2.core";
import MainService from "../services/MainService";
// import { WjComboBox } from "@grapecity/wijmo.vue2.input";
import utils from "../Utils/libraries";
import card from "@supervision/vue-components/components/Card.vue";
export default {
  name: "CardInfo",
  inject: ["accessToken"],

  components: { 
    // WjComboBox, 
    card 
  },
  setup() {
    return { utils };
  },
  watch: {
    currentScope(newVal) {
      if (newVal) {
        this.mainService = new MainService(this.$jwt.token, newVal);
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScope);
      }
    },
  },
  props: {
    Id: {
      type: Number,
      required: false,
      default: 0,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
     dataModel: {
      type: Object,
      required: false,

    },
    Collapsed: {
      type: Boolean,
      required: true,
    },
    classCSS: {
      type: String,
      required: true,
    },
  },
  data() {
    // const datesParams = ["ElectronicIndexDate", "MechanicalIndexDate"];
    return {
      hasRole: this.$jwt.hasAtLeastOneRole([
        "dm-administrator",
        "dm-assets-param-update",
      ]),
      glyphDown: glyphDown,
      mainService: new MainService(this.$jwt.token, this.$jwt.scope),
      currentScope: this.$jwt.scope,
      formData: {},
      formChangeData: {},
      formInitData: {},
      editable: false,
      culture: computed(() => this.$i18n.locale),
      theComboString: {},
      typeDevice: "",
      SpecificParams1G: ["TransmitterModule1GIdentifier"],
      componentKey: 0,
    };
  },
  methods: {
    initComboString: function (combo) {
      this.theComboString = combo;
    },
    hasTimeComponent(datetimeString) {
      // Define a regular expression for the time format HH:MM:SS
      const timeRegex = /\d{2}:\d{2}:\d{2}/;

      // Test if the datetimeString contains the time component
      return timeRegex.test(datetimeString);
    },
    isDateValue(dateString) {
      if (dateString == undefined && dateString == null || dateString == "") return false;
      const dateObject = new Date(dateString);
      return !isNaN(dateObject);
    },
    GetParameterTraduction(value) {
      var traduction = value;
      let x = this.items.filter((e) => e.key == value);
      if (!utils.isEmpty(x)) {
        let trad;

        if (!utils.isEmpty(x[0].Traductions)) {
          trad = x[0].Traductions.filter((e) => e.culture == this.culture);
          if (!utils.isEmpty(trad)) {
            return trad[0].value;
          } else {
            return x.key;
          }
        }
      }
      return traduction;
    },
    CreateArrayKeyValuesFromString(array) {
      let list = [];
      array.forEach((x) =>
        list.push({ value: x, name: this.GetParametersTraductionValue(x) })
      );
      return list;
    },
    GetParametersTraductionValue(value, key = null) {
      if (utils.isObject(value)) {
        
        if (this.translationExists("pages.DeviceDetails.ParametersValues." + value.value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value.value);
        else return value.value;
      } else {
        if (this.translationExists("pages.DeviceDetails.ParametersValues." + value))
          return this.$t("pages.DeviceDetails.ParametersValues." + value);
        if (key != null && key !== "ManufacturerDate" && key.toLowerCase().includes("date") && this.isDateValue(value)) {
          return this.$d(new Date(value), 'short');
        }
        return value;
      }
    },
    formHasChanged() {
      let change = JSON.stringify(this.formData).trim() !== JSON.stringify(this.formInitData).trim();
      if (change) this.save();
      return change;
    },
    RebaseForm() {
      this.formData = {...this.formInitData};
      this.formChangeData = {};
      this.$emit("eventemit", null, "title");
      this.componentKey++;
    },
    map(t) {
      return Object.entries(t).map((el) => {
        return {
          Key: el[0],
          Value: el[1],
        };
      });
    },
    translationExists(e) {
      return typeof this.$tm(e) == "string";
    },
    save() {
      //this.componentKey++
      this.items.forEach((e) => {
        if (this.formData[e.key] != this.formInitData[e.key]) {
          this.formChangeData[e.key] = this.formData[e.key];
        } else {
          if (this.formChangeData[e.key] != null) {
            this.formChangeData[e.key] = null;
          }
        }
      });
      
      let tmp = this.map(this.formChangeData);
      this.$emit("eventemit", tmp, "title");
    },
  },
  mounted() {
    console.log("per datamodel",this.dataModel);
    this.typeDevice = this.type;
    console.log("Received items: ", this.type, this.items);
    this.items.forEach((e) => {
      this.formData[e.key] = e.value;
      this.formInitData[e.key] = e.value;
    });
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #030f40 !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.card_header {
  font-family: D-DIN-500 !important;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  border-radius: 10px 10px 0px 0px !important;
  background-color: #bbdbfd !important;
  border-bottom: 1px solid #030f40 !important;
}
.card-header {
  font-family: D-DIN-500 !important;
  //padding: 0.5rem 1rem;
  margin-bottom: 0;
  border-radius: 10px 10px 0px 0px !important;
  background-color: #bbdbfd !important;
  border-bottom: 0px !important;
  // border-bottom: 1px solid #030f40 !important;
}
#maincard,
#maincard-header {
  background-color: #f4f6fb !important;
}
.card-header.collapsed {
  .rotateicon {
    transform: rotate(90deg);
    transition: 0.3s transform ease-in-out;
  }
  border-radius: 10px 10px 10px 10px !important;
}
.card-header:not(.collapsed) {
  .rotateicon {
    transition: 0.3s transform ease-in-out;
  }
  border-radius: 0px 10px 0px 0px !important;
}

.title-col-card {
  font-family: D-DIN-700 !important;
  font-style: normal !important;
  color: #6095d6;
}

.source {
  font-family: D-DIN-700 !important;
  font-style: normal !important;
  color: #adb5bdd4;
}

.row-padding-bottom-05 {
  padding-bottom: 0.5em;
}
.row-padding-bottom-10 {
  padding-bottom: 1em;
}
.row-padding-bottom-20 {
  padding-bottom: 2em;
}
.row-padding-bottom-30 {
  padding-bottom: 3em;
}

.icon {
  position: relative;
  top: 3px;
  font-size: 20px;
  margin-right: 15px;
}

.btn-success {
  color: #fff !important;
  background-color: #9bcd41 !important;
  border-color: #9bcd41 !important;

  border-radius: 5px !important;
  /* font-family: D-DIN !important;
  font-style: normal !important;
  font-weight: 500 !important; */
  font-size: 12px !important;
  align-items: center !important;
  width: 84px !important;
  height: 25px !important;
  justify-content: center !important;
  flex-direction: column !important;
  padding: 12px !important;
}
.btn-reset-form {
  color: #030f40;
  background-color: #ed6868;
  border-color: #ed6868;
  border-radius: 5px;
}
.btn-reset-form:hover {
  color: white;
  background-color: #ed6868;
  border-color: #ed6868;
  border-radius: 5px;
}
.dm-card-param-name {
  width: fit-content;
  display: flex;
  flex-direction: column;
}
.dm-align-left {
  margin-right: auto;
}
.dm-align-right {
  margin-left: auto;
}
</style>
